import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { LogoMark } from "../../components/Logo";
import { LayoutDashboard, Briefcase, Users, Mail, LogOut, Home, BookOpen, Phone } from "lucide-react";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-[#F4F7FA] text-[#0F2746] font-serif-ap text-xl">Yükleniyor...</div>;
  }
  if (!user) { navigate("/admin/login", { replace: true }); return null; }
  if (!user.is_admin) { navigate("/admin/login?error=not_admin", { replace: true }); return null; }

  const handleLogout = async () => { await logout(); navigate("/admin/login", { replace: true }); };

  const links = [
    { to: "/admin", end: true, label: "Panel", icon: LayoutDashboard, key: "dashboard" },
    { to: "/admin/home", label: "Ana Sayfa", icon: Home, key: "home" },
    { to: "/admin/about", label: "Hakkımızda", icon: BookOpen, key: "about" },
    { to: "/admin/services", label: "Hizmet Alanları", icon: Briefcase, key: "services" },
    { to: "/admin/team", label: "Ekip", icon: Users, key: "team" },
    { to: "/admin/contact", label: "İletişim Bilgileri", icon: Phone, key: "contact" },
    { to: "/admin/messages", label: "Mesajlar", icon: Mail, key: "messages" },
  ];

  return (
    <div className="min-h-screen bg-[#F4F7FA] flex">
      <aside className="w-64 bg-[#081A33] text-[#F3F5F8] flex flex-col">
        <div className="p-6 border-b border-[#F3F5F8]/10 flex items-center gap-3">
          <LogoMark className="w-8 h-8" color="#F3F5F8" />
          <div className="font-serif-ap text-lg">Alaca Partners</div>
        </div>
        <nav className="flex-1 p-3 space-y-1 mt-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.key}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm tracking-wide transition-colors ${
                  isActive ? "bg-[#C4A47C] text-[#0F2746]" : "text-[#F3F5F8]/70 hover:bg-[#0F2746] hover:text-[#F3F5F8]"
                }`
              }
            >
              <l.icon size={16} />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[#F3F5F8]/10">
          <div className="flex items-center gap-3 px-2 py-2">
            {user.picture && <img src={user.picture} alt="" className="w-8 h-8 rounded-full" />}
            <div className="flex-1 min-w-0">
              <div className="text-sm truncate">{user.name}</div>
              <div className="text-[10px] text-[#F3F5F8]/50 truncate">{user.email}</div>
            </div>
          </div>
          <button
            data-testid="admin-logout-btn"
            onClick={handleLogout}
            className="mt-3 w-full flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-wider text-[#F3F5F8]/60 hover:text-[#F3F5F8] hover:bg-[#0F2746] transition-colors"
          >
            <LogOut size={14} /> Çıkış
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
